import { Adal5HTTPService, Adal5Service } from 'adal-angular5';
import { HttpClient, HttpHandler } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from 'environments/environment';

@Injectable()
export class AuthService {

    private _user = null;

    private  full = `${location.protocol}//${location.hostname}${this.getPort()}`;


    private _config = {
        tenant: environment.tenant,
        clientId: environment.clientId,
        redirectUri: `${this.full}/auth-callback`,
        postLogoutRedirectUri: this.full
    }

    constructor(private _adal: Adal5Service) {
        this._adal.init(this._config);
    }

    public isLoggedIn(): boolean {
        return this._adal.userInfo.authenticated;
    }

    public signout(): void {
        this._adal.clearCache();
        this._adal.logOut();
    }

    public startAuthentication(): any {
        this._adal.login();
    }

    public getToken(): string {
        return this._adal.userInfo.token;
    }

    public getName(): string {
        const user = JSON.parse(localStorage.getItem('authentication.user'));
        return user.profile.name;
    }

    public completeAuthentication(): void {
        this._adal.handleWindowCallback();
        this._adal.getUser().subscribe(user => {
            localStorage.setItem('authentication.user', JSON.stringify(user));
            localStorage.setItem('authentication.token', user.token);
        });
    }

    private getPort() {
        if (location.port) {
            return `:${location.port}`;
        }

        return '';
    }
}



// WEBPACK FOOTER //
// ./src/app/auth.service.ts